'use client';

import Link from 'next/link';
import PropertyCard from '../../../components/PropertyCard';
import PropertyCarousel from '../../../components/PropertyCarousel';
import { useState, useEffect, useRef } from 'react';
import { api } from '@/lib/apiClient';
const BASE_URL = process.env.NEXT_PUBLIC_API_URL || '/api/proxy/';

// Mock data - API ready structure
const featuredProperties = [
    {
        id: 'prop-001',
        title: '3 BHK Premium Apartment in Adyar',
        price: 95,
        priceUnit: 'Lac',
        pricePerSqft: 8500,
        type: 'Apartment',
        bedrooms: 3,
        bathrooms: 2,
        area: 1120,
        areaUnit: 'sqft',
        locality: 'Adyar',
        city: 'Chennai',
        image: 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=600',
        imageCount: 8,
        badges: ['Ready to Move'],
        isNew: true,
        isVerified: true,
        isSaved: false,
        listingType: 'buy',
    },
    {
        id: 'prop-002',
        title: '2 BHK Modern Flat near IT Park',
        price: 68,
        priceUnit: 'Lac',
        pricePerSqft: 7200,
        type: 'Apartment',
        bedrooms: 2,
        bathrooms: 2,
        area: 945,
        areaUnit: 'sqft',
        locality: 'OMR',
        city: 'Chennai',
        image: 'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=600',
        imageCount: 12,
        badges: [],
        isNew: false,
        isVerified: true,
        isSaved: false,
        listingType: 'buy',
    },
    {
        id: 'prop-003',
        title: '4 BHK Luxury Villa with Pool',
        price: 2.5,
        priceUnit: 'Cr',
        pricePerSqft: 12000,
        type: 'Villa',
        bedrooms: 4,
        bathrooms: 4,
        area: 2200,
        areaUnit: 'sqft',
        locality: 'ECR',
        city: 'Chennai',
        image: 'https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=600',
        imageCount: 15,
        badges: ['Premium'],
        isNew: true,
        isVerified: true,
        isSaved: false,
        listingType: 'buy',
    },
    {
        id: 'prop-004',
        title: '3 BHK Apartment near Metro',
        price: 82,
        priceUnit: 'Lac',
        pricePerSqft: 7800,
        type: 'Apartment',
        bedrooms: 3,
        bathrooms: 2,
        area: 1050,
        areaUnit: 'sqft',
        locality: 'Velachery',
        city: 'Chennai',
        image: 'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=600',
        imageCount: 6,
        badges: ['No Brokerage'],
        isNew: false,
        isVerified: true,
        isSaved: false,
        listingType: 'buy',
    },
    {
        id: 'prop-005',
        title: 'Premium Villa in Whitefield',
        price: 3.2,
        priceUnit: 'Cr',
        pricePerSqft: 9500,
        type: 'Villa',
        bedrooms: 4,
        bathrooms: 4,
        area: 3200,
        areaUnit: 'sqft',
        locality: 'Whitefield',
        city: 'Bangalore',
        image: 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=600',
        imageCount: 10,
        badges: ['Premium'],
        isNew: true,
        isVerified: true,
        isSaved: false,
        listingType: 'buy',
    },
    {
        id: 'prop-006',
        title: '2 BHK Smart Home',
        price: 55,
        priceUnit: 'Lac',
        pricePerSqft: 6100,
        type: 'Apartment',
        bedrooms: 2,
        bathrooms: 2,
        area: 900,
        areaUnit: 'sqft',
        locality: 'Hitech City',
        city: 'Hyderabad',
        image: 'https://images.unsplash.com/photo-1493809842364-78817add7ffb?w=600',
        imageCount: 5,
        badges: ['Smart Home'],
        isNew: true,
        isVerified: true,
        isSaved: false,
        listingType: 'buy',
    },
    {
        id: 'prop-007',
        title: 'Seaview Penthouse',
        price: 4.5,
        priceUnit: 'Cr',
        pricePerSqft: 18000,
        type: 'Apartment',
        bedrooms: 4,
        bathrooms: 5,
        area: 4500,
        areaUnit: 'sqft',
        locality: 'Marine Drive',
        city: 'Mumbai',
        image: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=600',
        imageCount: 18,
        badges: ['Luxury'],
        isNew: false,
        isVerified: true,
        isSaved: false,
        listingType: 'buy',
    },
    {
        id: 'prop-008',
        title: 'Cozy Studio Apartment',
        price: 45,
        priceUnit: 'Lac',
        pricePerSqft: 9000,
        type: 'Studio',
        bedrooms: 1,
        bathrooms: 1,
        area: 500,
        areaUnit: 'sqft',
        locality: 'Koramangala',
        city: 'Bangalore',
        image: 'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=600',
        imageCount: 4,
        badges: ['Studio'],
        isNew: false,
        isVerified: true,
        isSaved: false,
        listingType: 'buy',
    },

];

const FeaturedProperties = () => {
    const handleSave = (propertyId) => {
        // API call to save property will go here
        console.log('Save property:', propertyId);
    };

    return (
        <section className="py-8 lg:py-8">
            <div className="container-custom">
                {/* Section Title */}
                <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-6">
                    <div className="section-title mb-4 md:mb-0">
                        {/* <span className="subtitle">Featured</span> - Removed as per request */}
                        <h2>New Properties</h2>
                        <p>Curated selection of premium properties just for you</p>
                    </div>
                    <Link href="/buy" className="btn btn-secondary self-start md:self-end">
                        View All
                        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                        </svg>
                    </Link>
                </div>

                {/* Properties Carousel - Buy */}
                <div className="relative">
                    <PropertyCarousel
                        properties={featuredProperties}
                        onSave={handleSave}
                    />
                </div>

                {/* Rent Section */}
                <div className="mt-10">
                    <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-6">
                        <div className="section-title mb-4 md:mb-0">
                            {/* <span className="subtitle">For Rent</span> - Removed as per request */}
                            <h2>Properties for Rent</h2>
                            <p>Find your perfect rental home</p>
                        </div>
                        <Link href="/rent" className="btn btn-secondary self-start md:self-end">
                            View All Rentals
                            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                            </svg>
                        </Link>
                    </div>

                    {/* Rental Properties Carousel */}
                    <div className="relative">
                        <PropertyCarousel
                            properties={featuredProperties.map(p => ({
                                ...p,
                                id: `rent-${p.id}`,
                                price: Math.floor(p.price * 250),
                                priceUnit: '',
                                pricePerSqft: null,
                                listingType: 'rent',
                            }))}
                            onSave={handleSave}
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FeaturedProperties;
